/**
 * Configuration des portails de souscription
 * Chaque portail définit son comportement spécifique
 */

const HUB_CONFIGS = {
    // Configuration pour les PER MMA
    PER_MMA: {
        type: 'per',
        provider: 'MMA',
        apiEndpoint: (contractId) => `/api/contracts/${contractId}/per`,
        spinnerText: 'Redirection vers le portail MMA en cours...',
        redirectUrl: (url) => url,
    },

    // Configuration pour les PER Cardif
    PER_CARDIF: {
        type: 'per',
        provider: 'Cardif',
        apiEndpoint: (contractId) => `/api/contracts/${contractId}/per`,
        spinnerText: 'Redirection vers le portail Cardif en cours...',
        redirectUrl: (url) => url,
    },

    // Configuration pour l'assurance vie MMA
    LIFE_INSURANCE_MMA: {
        type: 'lifeInsurance',
        provider: 'MMA',
        apiEndpoint: (contractId) => `/api/contracts/${contractId}/lifeInsurance`,
        spinnerText: 'Redirection vers le portail MMA en cours...',
        redirectUrl: (url) => url,
    },

    // Configuration pour l'assurance vie Primonial
    LIFE_INSURANCE_PRIMONIAL: {
        type: 'lifeInsurance',
        provider: 'Primonial',
        apiEndpoint: (contractId) => `/api/contracts/${contractId}/lifeInsurance`,
        spinnerText: 'Redirection vers le hub Primonial en cours...',
        redirectUrl: (url) => `/sso-redirect-primonial?url=${encodeURIComponent(url)}`,
    },

    // Configuration pour les actes de gestion
    MANAGEMENT_ACT: {
        type: 'managementAct',
        provider: 'Extranet',
        apiEndpoint: (managementActId) => `/api/contracts/managementAct/${managementActId}/`,
        spinnerText: 'Redirection vers l\'extranet en cours...',
        redirectUrl: (url) => url,
    },
};

/**
 * Messages d'erreur par défaut selon le code HTTP
 */
const DEFAULT_ERROR_MESSAGES = {
    400: 'Vérifier les données de la souscription.',
    403: 'Accès refusé.',
    404: 'Conseiller introuvable.',
    500: 'Plateforme indisponible.',
    default: 'Plateforme indisponible.',
};

/**
 * Récupère la configuration d'un portail
 * @param {string} configKey - Clé de configuration (ex: 'PER_MMA', 'LIFE_INSURANCE_PRIMONIAL')
 * @returns {object} Configuration du portail
 */
export const getHubConfig = (configKey) => {
    const config = HUB_CONFIGS[configKey];
    if (!config) {
        throw new Error(`Configuration de portail inconnue: ${configKey}`);
    }

    return config;
};

/**
 * Récupère le message d'erreur approprié
 * @param {number} status - Code HTTP
 * @param {string} customMessage - Message personnalisé (optionnel)
 * @returns {string} Message d'erreur
 */
export const getErrorMessage = (status, customMessage = null) => {
    if (customMessage) {
        return customMessage;
    }

    return DEFAULT_ERROR_MESSAGES[status] || DEFAULT_ERROR_MESSAGES.default;
};

export default HUB_CONFIGS;
